// PWA helpers — browser install prompt and detection utilities.
// Extracted from the old CRA serviceWorkerRegistration.js during
// the Vite migration. The actual SW registration is now handled
// by vite-plugin-pwa (workbox).

let deferredPrompt = null;

/**
 * Initialize the PWA install prompt listener.
 * Call once at app startup to capture the beforeinstallprompt event.
 */
export function initializeInstallPrompt(onInstallReady) {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    if (onInstallReady) {
      onInstallReady(true);
    }
  });

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
  });
}

/**
 * Trigger the browser install prompt.
 * Returns true if the user accepted, false otherwise.
 */
export async function showInstallPrompt() {
  if (!deferredPrompt) {
    return false;
  }
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  return outcome === 'accepted';
}

/**
 * Check whether the app is running as an installed PWA.
 */
export function isPWAInstalled() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}
